import React, { useRef, useImperativeHandle, forwardRef } from 'react';

const withFileUpload = WrappedComponent => {
  return forwardRef(({ onFileSelect, ...props }, ref) => {
    const fileInputRef = useRef();

    const handleClick = () => {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    };

    const handleFileChange = e => {
      const file = e.target.files[0];
      if (file && onFileSelect) {
        onFileSelect(file);
      }
    };

    useImperativeHandle(ref, () => ({
      reset: () => {
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
      }
    }));

    return (
      <>
        <WrappedComponent {...props} onClick={handleClick} />
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          onChange={handleFileChange}
          accept=".xlsx, .xls"
        />
      </>
    );
  });
};

export default withFileUpload;
